import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './component/HeroSection';
import PhysicalTherapyMoment from './component/PhysicalTherapyMoment';
import Condition from './component/Condition';
import Benefits from './component/Benefits';
import CareAndRecovery from './component/CareAndRecovery';
import ContactUsSection from './component/ContactUsSection';

const PhysicalTherapyPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Pediatric Physical Therapy Wasilla Alaska | Guidepost PT Services
        </title>
        <meta
          name="description"
          content="Pediatric physical therapy services in Wasilla, Alaska. Our PT specialists help children improve motor skills, balance, coordination, and overcome physical challenges through fun, tailored activities."
        />
        <meta
          name="keywords"
          content="pediatric physical therapy Wasilla, PT services Alaska, pediatric PT Wasilla, physical therapy for children, motor skills therapy Alaska"
        />
      </Helmet>
      <HeroSection />
      <PhysicalTherapyMoment />
      <Condition />
      <Benefits />
      <CareAndRecovery />
      <ContactUsSection />
    </div>
  );
};

export default PhysicalTherapyPage;
